export default __webpack_public_path__ + "static/media/company3.d85a9eeb.svg";